<template>
  <div class="layer">
      <div class="inner categoryInner">
        <button type="button" class="btnClose" @click="close"></button>
        <h2 class="layerTitle">{{locale.category}}</h2>
        <div class="innerContent">
          <div v-if="!collectionItemId" class="addCategory">
            <button type="button" class="btn btnWhite btnFull btnAdd" @click="addCategory"></button>
          </div>
          <CategoryTree
            :locale="locale"
            :list="list"
            :defaultLang="defaultLang"
            :collectionItemId="collectionItemId"
            :checked="checked"
            :checkLimit="checkLimit"
            :class="{innerBox: collectionItemId}"
            @removeItem="removeItem"
            @setItem="setItem"
            @setLanguage="setLanguage"
            @changeCheckedItem="changeCheckedItem" />
          <!-- 언어별 세팅 -->
          <LangValue v-show="langValueLayer"
            :locale="locale"
            :langValue="langValue"
            :title="locale.language_specific_set"
            @close="closeLanguage" />
          <!-- //언어별 세팅 -->
          <!-- 카테고리 상세 설정 -->
          <CategoryDetail v-if="categoryDetail"
            :locale="locale"
            :categoryId="categoryDetail"
            :categoryData="categoryDetailData"
            @apply="applyItem"
            @close="categoryDetail = null" />
          <!-- 카테고리 상세 설정 -->
      </div>
      <div v-if="!collectionItemId" class="btns">
        <button type="button" class="btn btnWhite" @click="close">{{ locale.cancel }}</button>
        <button type="button" class="btn btnPrimary" :disabled="isDisabled" @click="save">{{ locale.save }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import LANG from '@/common/lang'
import regExp from '@/common/regExp'
import UNIQUE from '@/common/unique'
import UTIL from '@/common/util'
import LangValue from '@/components/Util/LangValue'
import CategoryTree from './CategoryTree'
import CategoryDetail from './CategoryDetail'

export default {
  name: 'CollectionCategory',
  props: [
    'locale',
    'pageId',
    'defaultLang',
    'collectionItemId',
    'checked',
    'checkLimit'
  ],
  components: {
    LangValue,
    CategoryTree,
    CategoryDetail
  },
  computed: {
    getPageCategory () {
      return this.$store.getters['collection/getPageCategory']
    },
    isDisabled () {
      return !this.list.length
    }
  },
  async created () {
    if (this.getPageCategory) {
      this.list = this._.cloneDeep(this.getPageCategory)
    }
  },
  data () {
    return {
      list: [],
      langTarget: null,
      langValueLayer: false,
      langValue: {},
      categoryDetail: null,
      categoryDetailData: null
    }
  },
  methods: {
    addCategory () {
      this.list.push({
        isActive: true,
        categoryId: UNIQUE.uniqueId8(),
        categoryLabel: LANG.valueObj(''),
        useMain: false,
        mainType: 'image', // image 또는 banner
        mainImage: '',
      })
    },
    setLanguage (categoryId, categoryLabel) {
      const fillLangs = UTIL.fillLangs(categoryLabel, categoryLabel[this.defaultLang])
      categoryLabel = fillLangs
      this.langTarget = categoryId
      this.langValueLayer = true
      this.langValue = categoryLabel
    },
    closeLanguage () {
      const categoryId = this.langTarget
      const targetItem = findCategoryItem(this.list, categoryId)
      function findCategoryItem(array, categoryId) {
        for (const item of array) {
          if (item.categoryId === categoryId) {
            return item
          }
          if (item.subCategory && Array.isArray(item.subCategory)) {
            const found = findCategoryItem(item.subCategory, categoryId)
            if (found) {
              return found
            }
          }
        }
        return null
      }
      if (targetItem) {
        targetItem.categoryLabel = this.langValue
      }
      this.langTarget = null
      this.langValueLayer = false
      this.langValue = {}
    },
    removeItem (categoryId) {
      function removeCategoryById (data, targetId) {
        // 깊은 복사 (원본 보존)
        function recursiveFilter(arr) {
          return arr.map(item => {
            // 하위 카테고리가 있는 경우 재귀 처리
            if (item.subCategory) {
              item.subCategory = recursiveFilter(item.subCategory)
            }
            return item
          }).filter(item => item.categoryId !== targetId)
          // 현재 배열에서 targetId와 일치하는 항목 제거
        }
        return recursiveFilter(data)
      }
      const list = removeCategoryById(this.list, categoryId)
      this.list = list
    },
    changeCheckedItem (data) {
      this.$emit('changeCheckedItem', data)
    },
    setCategoryDetail(categoryId) {
      function findCategoryById(data, targetId, parent = null) {
        for (const item of data) {
          if (item.categoryId === targetId) {
            const hasSubCategory = item.subCategory?.length > 0
            const isBannerItem = parent?.useMain && parent?.mainType === 'banner'
            return {
              isActive: item.isActive,
              categoryId: item.categoryId,
              categoryLabel: item.categoryLabel,
              useMain: item.useMain,
              mainType: item.mainType,
              mainImage: item.mainImage,
              hasSubCategory: hasSubCategory,
              isBannerItem: isBannerItem, // 상위카테고리가 배너형 메인인지? (이 아이템이 배너아이템인지?)
            }
          }
          if (item.subCategory && Array.isArray(item.subCategory)) {
            const found = findCategoryById(item.subCategory, targetId, item)
            if (found) return found
          }
        }
        return null
      }
      this.categoryDetail = categoryId
      this.categoryDetailData = findCategoryById(this.list, categoryId)
    },
    setItem (categoryId) {
      this.setCategoryDetail(categoryId)
    },
    applyItem (data) {
      const categoryId = data.categoryId
      const categoryInfo = data.info
      function updateCategoryTree (categoryList, targetId, info) {
        // 깊은 복사하여 원본 배열을 훼손하지 않도록 처리
        const updatedList = categoryList.map(item => {
          const newItem = { ...item }
          // 일치하는 항목이면 info로 대체 (categoryId는 유지)
          if (newItem.categoryId === targetId) {
            return {
              ...newItem,
              ...info
            }
          }
          // 하위 subCategory가 있는 경우 재귀 호출
          if (newItem.subCategory && Array.isArray(newItem.subCategory)) {
            newItem.subCategory = updateCategoryTree (newItem.subCategory, targetId, info);
          }
          return newItem
        })
        return updatedList
      }
      this.list = updateCategoryTree(this.list, categoryId, categoryInfo)
    },
    close () {
      this.$emit('close')
    },
    async save () {
      const filteredLanguageValues = this.$store.getters['util/filteredLanguageValues']
      const data = {
        pageId: this.pageId,
        categories: transformCategoryLabels(this.list, filteredLanguageValues)
      }
      // categoryLabel의 사용하는 언어만 남기고 삭제하여 카테고리 전체 리스트를 리턴
      function transformCategoryLabels (data, filterFunc) {
        return data.map(item => {
          const transformedItem = {
            ...item,
            categoryLabel: filterFunc(item.categoryLabel),
          }
          if (item.subCategory) {
            transformedItem.subCategory = transformCategoryLabels(item.subCategory, filterFunc)
          }
          return transformedItem
        })
      }
      this.$store.commit('onLoading', true)
      const res = await this.$store.dispatch('collection/putCollectionCategory', data)
      if (res?.status === 200) {
        alert(this.locale.complete_save)
        this.$emit('reload')
        this.$emit('close')
      }
      this.$store.commit('onLoading', false)
    },
    
  }
}
</script>

<style lang="scss" scoped>
.addCategory {
  .btnAdd {
    background-color: $color-white;
  }
}
.innerContent {
  flex: 1;
  overflow: auto;
}
</style>
